export default "__VITE_ASSET__d4b43b50__"